import { useTranslation } from 'react-i18next';

const LANGS = [
  { code: 'en', label: 'EN' },
  { code: 'zh', label: '中' },
] as const;

export default function LangToggle() {
  const { i18n } = useTranslation();
  const current = i18n.language.startsWith('zh') ? 'zh' : 'en';

  return (
    <div className="inline-flex border border-hairline rounded-full overflow-hidden">
      {LANGS.map((l, i) => {
        const active = current === l.code;
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => i18n.changeLanguage(l.code)}
            aria-pressed={active}
            className={
              'font-mono text-[11px] px-2.5 py-1 transition ' +
              (active ? 'bg-ink text-ink-inv' : 'text-ink-3 hover:text-ink') +
              (i < LANGS.length - 1 ? ' border-r border-hairline' : '')
            }
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
}
